import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_import_new_posts = _resolveComponent("import-new-posts")!
  const _component_import_initiated = _resolveComponent("import-initiated")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_ctx.request)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.request.assignee === 'client')
          ? (_openBlock(), _createBlock(_component_import_new_posts, {
              key: 0,
              account: _ctx.account
            }, null, 8, ["account"]))
          : (_ctx.request.assignee === 'support')
            ? (_openBlock(), _createBlock(_component_import_initiated, {
                key: 1,
                account: _ctx.account
              }, null, 8, ["account"]))
            : _createCommentVNode("", true),
        _createVNode(_component_q_separator, { class: "q-mt-lg" })
      ]))
    : _createCommentVNode("", true)
}